// much of the checkbox logic was based off of this codesandbox: https://codesandbox.io/s/usecontroller-checkboxes-forked-uhxd2?file=/src/App.js:837-869
import classNames from "classnames"
import { useController } from "react-hook-form"
import { xor } from "lodash"
import { FieldOption } from "../../types/FieldOption"
import { FieldProps } from "../../types/FieldProps"
import { FormErrorText } from "../FormErrorText"
import { FormHelperText } from "../FormHelperText"
import { FormLabel } from "../FormLabel"

export interface CheckboxGroupProps extends FieldProps {
  options: FieldOption[]
  className?: string
}

export function CheckboxGroup(props: CheckboxGroupProps) {
  const {
    field,
    fieldState: { error },
  } = useController(props)

  const { options, helperText, label, name, className, optional } = props

  return (
    <div className={classNames("flex flex-col", className)}>
      <fieldset>
        <legend>
          {label || name}
          {!optional && <span className="text-red-500">*</span>}
        </legend>
        {helperText?.length ? (
          <FormHelperText className="pb-[var(--alias-padding-xxs)]">
            {helperText}
          </FormHelperText>
        ) : null}
        {options.map(({ value: option, label }) => (
          <div
            className="flex items-center py-[var(--component-radio-space-tight)]"
            key={String(option)}
          >
            <input
              onChange={(e) => {
                const newValue = xor(field.value || [], [e.target.value])
                field.onChange(newValue)
              }}
              defaultChecked={field.value?.includes(option)}
              type="checkbox"
              id={String(option)}
              value={option}
            />
            <FormLabel className="pl-2" htmlFor={String(option)}>
              {label}
            </FormLabel>
          </div>
        ))}
        {error && (
          <FormErrorText className="pt-[var(--alias-padding-xxs)]">
            {error.message}
          </FormErrorText>
        )}
      </fieldset>
    </div>
  )
}
